/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Home_How_Step3Inputs */



/**
* | output |
* | --- |
* | "The bill counts toward the month its period ends in. That month's ERP file contains it." |
*
* @param {Partner_Home_How_Step3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_home_how_step3 = /** @type {((inputs?: Partner_Home_How_Step3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Home_How_Step3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Abrechnung zählt zu dem Monat, in dem ihr Zeitraum endet. Die ERP-Datei dieses Monats enthält sie.")
	return /** @type {LocalizedString} */ ("The bill counts toward the month its period ends in. That month's ERP file contains it.")
});